import React from 'react'
import key from "./assets/img_warning.svg"
import doorkey_warning from "./assets/doorkey_warning.png"
import { CMSPath } from '../../../config/constant'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'

function DoorKeyWarning(props) {
	return (

		<div className='help-info'>

			<header class="inner-pages w-footer subpages">
				<a onClick={props.cancel} className="button-back"></a>
				<div class="heading align-center">
					<div class="splash-brand">
						<img src={`${CMSPath}${props.logo}`} />
					</div>
				</div>
			</header>

			<section class="widgets padding-0 margin-0 container-bg" style={{ minHeight: "100vh" }} >

				<div class="widget-header widget-header-doorkey-howto">
					<div class="widget-header-title">Digital DoorKey</div>
				</div>

				<div class="multi-tips gallery-alt">

					<div class="multi-tips-main">
						<div class="multi-tips-container">
							<div class="multi-tips-item">
								<div class="multi-tips-img">
									<img src={doorkey_warning} alt="doorkey warning" />
								</div>
								<div class="multi-tips-body">
									<p class="heading" >Doorkey</p>
									<p>Logging out will revoke the access to digital key.</p>
									<p class="subtext">*You will need to repeat the authentication process to gain access to your door key from your device.</p>
								</div>
							</div>
						</div>
					</div>

						<div class="multi-tips-controls">
							<button onClick={props.continue} disabled={props.loggingOut} class="button primary">Continue</button>
							<button onClick={props.cancel} disabled={props.loggingOut} class="button">Cancel</button>
						</div>

						<div class="multi-tips-pages"></div>
						
				</div>
			</section>
		</div>
	)
}

const mapStateToProps = state => {
	return{
	  logo: state.store.home.currentDuration.brandingInfo ?
			  state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
	}
}
  
export default connect(mapStateToProps,{})(withTranslation('translations')(DoorKeyWarning));